import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class SortIconBaseValueConverter {
    toView(array : Array<any>, columnName: string) {
        if(ObjectHelper.IsNotNullAndUndefined(array) && array.length > 0) {
            
            let item = array.filter((item) => item['ColumnName'] != null && item['ColumnName'] == columnName);

            if(ObjectHelper.IsNotNullAndUndefined(item) && item.length > 0) {
                return 'fa-sort' + '-' + item[0]['Direction'].toLowerCase();                
            }
        }

        return 'fa-sort';
    }
}